import moment from 'moment-mini'
/**
 *
 * @param formData
 * 浅清空 data
 *  格式 {name:'' obj:{}, array:[]}
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EmptyForm = (formData: any) => {
  for (const k in formData) {
    if (formData[k] instanceof Object) {
      formData[k] = {}
    } else if (formData[k] instanceof Array) {
      formData[k] = []
    } else {
      formData[k] = ''
    }
  }
}

/**
 * copyFn  复制功能
 * @param data 复制内容
 */
export const copyFn = (data: string): boolean => {
  try {
    const textarea = document.createElement('textarea') as HTMLTextAreaElement
    textarea.value = data
    textarea.style.height = '0'
    textarea.style.width = '0'
    const body: HTMLBodyElement = document.querySelector(
      'body'
    ) as HTMLBodyElement
    body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    body.removeChild(textarea)
    return true
  } catch (e) {
    return false
  }
}

export const splitFn = (str: string, str1: string, num: number): string =>
  str.split(str1)[num]

// 最大值函数
export const MaxFn = (data: number[]): number => Math.max(...data)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const maxNumber = (data: any[], type: string | null = null): number => {
  if (type) {
    return MaxFn(data.map(item => item[type]))
  } else {
    return MaxFn(data)
  }
}

export const sessionSetItem = (key: string, value: string | Array<string> | object) => {
  let _value = ''
  if ((typeof value) === 'string') {
    _value = (value as string)
  } else {
    _value = JSON.stringify(value)
  }
  window.sessionStorage.setItem(key, _value)
}

export const sessionGetItem = (key: string) => {
  const res = window.sessionStorage.getItem(key)
  if (res) {
    try {
      return JSON.parse(res)
    } catch (error) {
      return res
    }
  } else {
    return null
  }
}

export const minToFormatDate = (min: number): string => {
  const time = moment.duration(min, 'seconds')
  const hours = time.hours()
  const minutes = time.minutes()
  const seconds = time.seconds()
  return moment({ h: hours, m: minutes, s: seconds }).format('HH:mm:ss')
}

export const dateFormat = (date: Date, format = 'YYYY-MM-DD hh:mm:ss') => {
  return moment(date).format(format)
}

// 消息弹框
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const messageBoxFn = (_that: any, fn: Function) => {
  _that.$confirm('是否执行该操作?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  })
    .then(() => {
      fn(true)
    })
    .catch(() => {
      _that.$message({
        type: 'info',
        message: '已取消该操作'
      })
      fn(false)
    })
}
